export default {
  ApiErrors: {
    generic: 'Une erreur est survenue. Veuillez recharger la page, et contactez-nous si le problème persiste.',
    'Email already exists': 'E-mail non disponible',
    'This field is required.': 'Ce champ doit être renseigné',
    'First_name must be filled': 'Le prénom doit être renseigné',
    'Password length must be over 8 characters': 'La longueur du mot de passe doit être de 8 caractères minimum',
    'Unable to login with the provided credentials': 'Impossible de se connecter avec les informations fournies',
    'godson is already a customer': 'Cet e-mail appartient déjà à un client',
    'godson is in referral process': 'Cet e-mail est déjà en cours de parrainage.',
    'Enter a valid email address': "Ceci n'est pas une adresse e-mail correcte",
    'Email already in db': 'E-mail non disponible',
    'Not an email': 'E-mail non valide',
    'Reward is soldout': 'Cette récompense est en rupture de stock',
    'Reward can only be claimed once': 'Vous avez déjà réclamé cette récompense',
    'Reward is no longer valid': "Cette récompense n'est plus valide",
    'Not enough points': "Vous n'avez pas assez de points",
    'Account already in use': 'Ce compte est déjà utilisé par un autre utilisateur',
    'This instagram account does not exist on Instagram': "Ce compte Instagram n'existe pas",
    'social error': "Veuillez entrer votre compte {'@'}mon_compte",
    'required field': 'Veuillez compléter ce champ',
    'value error': "La valeur entrée n'est pas correcte",
    'You already applied a discount code': 'Vous avez déjà appliqué un code de réduction'
  },
  Error: {
    generic: 'Une erreur s’est produite, veuillez recharger la page.',
    link: 'Recharger la page',
    title: 'Loyoly - Oups ! Erreur',
    blacklistMessage1: 'Vous n’êtes pas éligible au programme de fidélité.',
    blacklistMessage2: 'Contactez l’équipe support si vous pensez que c’est une erreur.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Veuillez renseigner une adresse e-mail correcte',
      emailEmpty: 'Veuillez renseigner votre adresse e-mail'
    }
  },
  InApp: {
    message: 'Pour avoir une expérience optimale, rendez-vous sur votre navigateur par défaut'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Code du pays',
      error: 'Choisissez un pays',
      searchPlaceholder: 'Sélectionnez un pays'
    },
    phoneInput: {
      placeholder: 'Numéro de téléphone',
      example: 'Exemple :'
    },
    error: {
      invalid: 'Veuillez renseigner un numéro téléphone valide'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Connexion à mon compte Instagram',
      subtitle: 'Comment ça marche',
      description:
        'Merci de renseigner votre compte Instagram et de vous assurer qu’il soit public avant de réaliser les missions.',
      form: {
        username: 'Compte Instagram',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Veuillez renseigner le nom de votre compte',
        usernameNotFound: 'Veuillez renseigner un nom de compte valide'
      },
      button: 'Valider'
    },
    ModalSearching: {
      title: 'Nous recherchons votre compte'
    },
    ModalLinked: {
      title: 'Connexion à mon compte Instagram',
      private: {
        subtitle: 'Connexion avec votre compte impossible',
        description: {
          title: 'Votre compte Instagram est privé',
          text: 'Mince, il semblerait que votre compte Instagram soit privé. Passez-le en mode public afin d’avoir accès à toutes les missions.'
        }
      },
      public: {
        subtitle: 'Connexion avec votre compte réussie',
        description: {
          title: 'Félicitations',
          text: 'Vous pouvez dès maintenant réaliser les missions.'
        }
      },
      buttons: {
        edit: 'Modifier mon compte',
        retry: 'Réessayer',
        goback: 'Revenir à la page',
        gotoChallenge: 'Accéder à la mission'
      }
    },
    ModalNotFound: {
      title: 'Connexion à mon compte Instagram',
      subtitle: 'Connexion avec votre compte impossible',
      description: {
        title: 'Compte introuvable',
        text: 'Nous vous invitons à changer de compte ou à faire une demande au support.'
      },
      buttons: {
        change: 'Changer de compte',
        retry: 'Réessayer'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'Notification par e-mails',
      information: {
        title: 'Informations',
        text: 'Si vous ne souhaitez pas recevoir des rappels de missions, des actualités ou des rappels de récompenses, vous pouvez vous désabonner en désactivant les checkbox ci-dessous :'
      },
      communication: {
        optinTransactional: 'Promotionnels : informations sur le programme, les paliers VIP, les récompenses.',
        optinMarketing: 'Informatifs : Informations sur les achats et le parrainage.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Compte public',
        private: 'Compte privé',
        followers: '<span class="weglot-ignore">{n}</span> abonné | <span class="weglot-ignore">{n}</span> abonnés'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> point | <span class="weglot-ignore">{n}</span> points',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> point | <span class="weglot-ignore">{value}</span> points',
  SectionHeader: {
    poweredBy: 'Propulsé par'
  },
  SectionChallenges: {
    empty: 'Il n’y a pas de missions disponibles dans votre programme de fidélité',
    showAll: 'Tout afficher',
    ModalMissionDetail: {
      description: 'Description',
      pointsToEarn: 'Points à gagner',
      howto: 'Comment ça marche ?',
      uploadMedia: 'Importer votre média',
      reviewApplication: 'Déposer un avis',
      linkApplication: "Télécharger l'application",
      newsletterPartners:
        'En cliquant sur “Valider la mission”, vous acceptez de recevoir des propositions commerciales de l’entreprise par voie éléctronique.',
      phonePartners: "J'accepte que mon numéro de téléphone soit utilisé pour recevoir des offres SMS.",
      clue: 'Indice',
      linkPage: 'Voir la page',
      instaMention: 'Identifiez',
      tiktokMention: 'Identifiez',
      instaHashtags: 'Hashtag(s) à utiliser',
      tiktokHashtags: 'Hashtag(s) à utiliser',
      linkToShare: 'Lien à mettre dans votre story',
      linkShare: 'Lien à partager',
      vouchertoShare: 'Code promotionnel à partager',
      goToAccount: 'Aller sur le compte',
      goToInsta: 'Aller sur le compte',
      goToInstaPost: 'Aller vers le post Instagram',
      goToInstaReel: 'Aller vers le reel Instagram',
      goToInstaIGTV: "Aller vers l'IGTV Instagram",
      goToTweeterTweet: 'Aller vers le Tweet',
      goToReview: 'Déposer un avis',
      goToShop: 'Aller vers la boutique',
      goToLink: 'Aller à la page',
      goToTypeform: 'Compléter le formulaire',
      goToWhatsapp: 'Rejoindre le groupe',
      submit: 'Valider la mission',
      missionPendingTitle: 'Mission en cours de vérification',
      missionPendingExplain: 'Vos points vous seront bientôt crédités.',
      actionSurveyTextError: 'Merci de sélectionner une réponse',
      actionEmailError: "Votre e-mail n'est pas valide",
      actionInputError: "Ce champ n'est pas valide",
      actionInputImageError: "Merci d'importer votre média",
      handlingMedia: 'Traitement du média',
      errorMediaHandle: 'Une erreur est survenu lors du traitement de votre média',
      imageInvalid: 'Une erreur est survenu lors du traitement de votre média',
      videoSize: 'La taille de votre vidéo doit être inférieure à 100 Mo.',
      errorInstaReel: "L'URL de votre reel est incorrecte",
      'This url is not a valid google url': "L'url de votre avis google est invalide",
      'This url is not a valid reel url': "L'URL de votre reel est incorrecte",
      refusalReasonCondition: 'Non respect des conditions',
      refusalReasonQuality: 'Qualité trop faible',
      refusalReasonContent: 'Contenu innaproprié',
      refusalReasonSound: 'Son inaudible',
      missionInvalidTitle: 'Mission invalidée',
      missionInvalidDescription: 'Vous pouvez refaire la mission en respectant attentivement les règles demandées',
      missionInvalidReasons: 'Raison refus :',
      condition: 'Conditions',
      conditionExplanation: 'Avoir plus de',
      ineligible: 'Non éligible',
      ineligibleExplanation:
        'Il semblerait que vos n’ayez pas le nombre d’abonnés requis. Si vous avez plus d’abonnés, nous vous invitons à mettre à jour les données de votre compte.',
      lastUpdate: 'Dernière mise à jour le',
      updateAccount: 'Mettre à jour mon compte',
      reviewLastPurchase: 'Déposer un avis sur la fiche produit de votre dernier achat',
      whenReviewValidated: 'Dès que l’avis sera validée, votre mission se validera automatiquement',
      pointsToEarnPhoto: 'Points supplémentaire si photo',
      pointsToEarnVideo: 'Points supplémentaire si vidéo',
      howtoBirthdate: 'Renseignez votre date d’anniversaire',
      errorInvalidDate: 'Veuillez renseigner une date valide',
      inputMedia: 'Importer votre média',
      inputMediaLoaded: 'Votre média a bien été importé',
      placeholderAnswer: 'Écrivez votre réponse ici',
      misteryAnswer: 'Quel est le mot mystère ?',
      newsletterEmail: 'Confirmez votre adresse e-mail',
      birthDate: 'Date d’anniversaire',
      example: 'Exemple',
      goToChallenge: 'Accéder à la mission'
    },
    ModalMissionImageRights: {
      imageRights:
        "En cochant cette case, je confirme être l'auteur du contenu, accepte expressément de céder les droits de propriété intellectuelle qui s'y rattachent, et autorise l'exploitation de mon image par la marque à des fins commerciales dans les conditions et modalités précisées dans ",
      imageRightsLink: 'cet accord.',
      title:
        'Accord de cession de droit de propriété intellectuelle sur le contenu et autorisation d’exploitation de mes attributs de la personnalité.',
      content:
        'J’accepte expressément que la publication du contenu réalisé dans le cadre de ma mission (le « Contenu ») :',
      bullet1:
        'emporte cession, au profit de la marque, de l’intégralité des droits d’auteur y afférents, et ce, pour le monde entier, pour toute la durée légale de protection du droit d’auteur à titre exclusif et définitif. Je reconnais que cette cession est consentie en contrepartie des points gagnés dans le cadre de ma mission, qui en constituent la juste-contrepartie.Cette cession comporte le droit de reproduction et de représentation du Contenu par la marque, en tout ou en partie, sur tous supports et par tous moyens, existants ou à venir,prévisibles ou imprévisibles, ainsi que le droit de traduire, arranger, modifier, adapteret/ou corriger le Contenu par la marque, seule ou en collaboration avec une tierce personne. Je m’engage à ce que ce Contenu n’enfreigne pas les droits des tiers, ni ne constitue un acte de contrefaçon et garantit la marque à ce titre ;',
      bullet2:
        'emporte autorisation de la marque, à titre gracieux, à fixer, reproduire, diffuser et communiquer au public les attributs de ma personnalité associés au Contenu, sur tous supports et par tous procédés connus ou inconnus à ce jour, prévisibles ou imprévisibles et à travers tout média, réseaux et moyens de diffusion à des fins d’exploitation, d’information, de communication, de promotion et de publicité des produits de la marque et pour une durée de 10 ans qui pourra être prorogée le cas échéant, par accord réciproque.',
      end1: 'Le présent accord est soumis au droit français et sera régi et interprété selon ce droit.',
      end2: "Tout litige pouvant naître à l'occasion de sa validité, de son interprétation ou de son exécutionsera soumis à la compétence exclusive des Tribunaux de Paris, sauf règle de procédure"
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> point à gagner tous les <span class="weglot-ignore">{amountToPoints}</span> dépensés | <span class="weglot-ignore">{points}</span> points à gagner tous les <span class="weglot-ignore">{amountToPoints}</span> dépensés',
      orderNumber: 'Commande N°',
      orderDate: 'Date',
      orderAmount: 'Montant',
      orderRewardable: 'Récompensable',
      orderPoints: 'Points gagnés',
      orderPaid: 'Validé',
      orderStatus: 'Statut',
      orderCancel: 'Remboursé',
      orderRefund: 'Partiellement remboursé',
      orderWaiting: 'En attente'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Voir les conditions',
      seePrivacy: 'Voir la politique de confidentialité'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Connexion à Instagram',
      tiktok: 'Connexion à TikTok'
    },
    notificationsByEmails: 'Notifications par e-mails',
    cgu: 'Conditions générales'
  },
  SectionAccountRewards: {
    empty: 'Il n’y a plus de récompenses à échanger et vous n’avez pas de récompenses en attente d’être utilisées',
    copied: 'Copié !'
  },
  SectionRewards: {
    empty: 'Il n’y a pas de récompenses disponibles dans votre programme de fidélité',
    showAll: 'Tout afficher',
    Card: {
      channel_store: 'En boutique',
      channel_online: 'En ligne',
      channel_both: 'En ligne et en boutique'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'Mes récompenses',
    empty: 'Vous n’avez pas encore de récompenses.',
    emptyTip: 'Vous pouvez faire des missions et échanger vos points gagnés contre des récompenses',
    use: 'Utiliser',
    expired: 'Expirée'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Date d’expiration',
    expirationDelayExplain:
      'La récompense sera utilisable pendant <span class="weglot-ignore">{expiration_delay}</span> jours lorsque vous l’aurez échangée.',
    minimumBuy: "Minimum d'achat",
    maxAmount: 'Valable dans la limite de',
    description: 'Description',
    saleChannel: 'Canal de vente',
    channelStore: 'En boutique',
    channelOnline: 'En ligne',
    channelBoth: 'En ligne et en boutique'
  },
  SectionRewardsDetailModal: {
    exchange: 'Échanger',
    errorMessage1: 'Il semblerait qu’un problème soit survenu.',
    errorMessage2: 'Votre récompense n’a pas été échangée et vos points n’ont pas été retirés.',
    errorMessage3: 'Veuillez recharger la page.',
    errorButton: 'Recharger la page'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'Comment ça marche ?',
    howItWorkCode: 'Utilisez votre code sur notre site web lors de votre commande',
    howItWorkCodeProduct: 'Ajoutez le produit à votre panier puis utilisez votre code lors de votre commande',
    howItWorkCodeRecharge: 'Ajoutez le code directement dans votre portail client',
    howItWorkExt: 'Vous serez contacté pour obtenir votre récompense',
    applyToBasket: 'Appliquer au panier',
    apply: 'Appliquer',
    applied: 'Appliqué',
    link: 'Lien vers le produit',
    copied: 'Copié !',
    customerPortal: 'Portail client',
    nonApplicable: 'Abonnement non éligible'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Appliquer',
    nonApplicable: 'Non éligible',
    itemTitle: '{title} / {price}'
  },
  SectionReferral: {
    friendEmail: 'E-mail de votre ami',
    seeReferral: 'Voir mes parrainages',
    errors: {
      emailSelf: "L'e-mail saisie est identique à votre e-mail"
    },
    Tabs: {
      link: 'Lien',
      email: 'E-mail',
      sms: 'SMS',
      copy: 'Copier le lien',
      smsSend: 'Envoyez un message',
      reward1: '{amount} points',
      reward2: '{amount}% de réduction',
      reward3: 'bon d’achat de {amount}',
      smsTemplate:
        "Bonjour ! J’ai découvert {brand_name} qui pourrait te plaire.\n\n En utilisant mon lien de parrainage {referral_link}, tu bénéficieras de {reward_friend}.\n\nProfites-en, c'est une offre vraiment intéressante !\nÀ bientôt !"
    },
    Modal: {
      emptyState: 'Vous n’avez réalisé aucun parrainage pour le moment',
      title: 'Mes parrainages',
      status: 'Statut',
      email: 'E-mail',
      date: "Date d'expiration",
      statusPending: 'En attente',
      statusUsed: 'Déjà utilisé',
      statusAvailable: 'Disponible',
      statusExpired: 'Expiré',
      statusInvalidate: 'Invalidé',
      promocodeComing: 'À venir',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Invalidé',
      points_given: 'Vos points ont été crédités',
      referral_type_3: "Bon d'achat",
      referral_type_2: 'Code promotionnel',
      referral_type_1: 'Points'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'E-mail',
      emailError: 'Le format de l’e-mail n’est pas respecté',
      emailEmpty: 'Veuillez renseigner ce champ',
      emailUnknown: 'Veuillez créer un compte pour pouvoir parrainer'
    }
  },
  SectionVipTiersProgress: {
    you: 'Vous',
    points: 'points'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} points offerts',
    rewardMultiplier: 'Multiplicateur de points : x{multiplier}',

    tiersPoints: '{amount} points'
  },
  SectionGifting: {
    empty: 'Il n’y a aucun test produit disponible pour le moment',
    showAll: 'Tout afficher',
    ModalApply: {
      endDate: 'Date de fin des candidatures',
      description: 'Description',
      completeForm: 'Complétez le formulaire pour soumettre votre candidature',
      button: 'Postuler',
      success: {
        title: 'Inscription au test produit',
        description:
          'Merci, d’avoir complété vos informations. Votre candidature est en cours d’examen. Vous serez averti par e-mail.'
      },
      Form: {
        Errors: {
          required: 'Veuillez compléter ce champ',
          date: 'Veuillez renseigner une date valide'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Missions',
      howItWorks: 'Comment ça marche ?',
      useCode: 'Utilisez votre code sur notre site web lors de votre commande.',
      youWillBeContacted: 'Vous serez contacté pour récupérer votre produit.',
      buttonLink: 'Lien vers le produit',
      buttonCopied: 'Copié !'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Participer',
      underValidation: 'En cours de validation',
      apply: 'Postuler',
      ended: 'Terminé',
      rejected: 'Candidature non retenue'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} mois| {n} mois'
    },
    ModalActivities: {
      title: 'Mes activités récentes',
      empty: 'Vous n’avez pas encore d’activités récentes.',
      table: {
        header: {
          title: 'Titre',
          points: 'Points',
          date: 'Date'
        }
      },
      events: {
        challenge: 'Mission validée',
        order: 'Achat effectué',
        reward: 'Récompense obtenue',
        refferal: 'Parrainage validé',
        userAction: 'Points ajustés',
        level: 'Palier atteint',
        levelLabel: 'Palier {level}',
        reset: 'Expiration des points',
        automation: 'Points gagnés'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Connexion à mon compte TikTok',
      subtitle: 'Comment ça marche',
      description:
        'Merci de renseigner votre compte Tiktok en vous assurant qu’il soit public. Vous pourrez alors réaliser des missions Tiktok.',
      button: 'Lier mon compte'
    },
    ModalLinked: {
      title: 'Connexion à mon compte TikTok',
      subtitle: 'Connexion avec votre compte réussie',
      congratulations: 'Félicitations',
      description: 'Vous pouvez dès maintenant réaliser les missions.',
      buttons: {
        edit: 'Modifier mon compte',
        goback: 'Revenir à la page'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Adresse e-mail',
    emailError: 'Veuillez renseigner une adresse e-mail correcte',
    emailEmpty: 'Veuillez renseigner votre adresse e-mail',
    disclaimer: 'Cette offre fonctionne uniquement pour les nouveaux clients',
    disclaimerVerification: 'Vous ne serez pas recontacté à des fins commerciales.',
    referral_type_3: "Bon d'achat",
    referral_type_2: 'Code promotionnel',
    referral_type_1: 'Points',
    copied: 'Copié !',
    label_optin_reminder: 'Je souhaite recevoir un rappel si je n’utilise pas ma réduction.',
    btn_optin_reminder: 'Recevoir un rappel de mon code'
  },
  Unsubscribe: {
    title: 'Souhaitez-vous vraiment vous désinscrire des e-mails de notre programme de fidélité ?',
    description:
      'Si c’est le cas, sachez que vous ne pourrez plus recevoir d’informations concernant vos récompenses, vos missions, vos points.',
    email: 'E-mail',
    button: 'Mettre à jour mes préférences',
    question: 'Quel type d’e-mail souhaitez-vous recevoir :',
    optinTransactional: 'Promotionnels : informations sur le programme, les paliers VIP, les récompenses.',
    optinMarketing: 'Informatifs : Informations sur les achats et le parrainage.',
    successTitle: 'Vos préférences ont été mises à jour',
    successDescription: 'Utilisez le bouton ci-dessous pour revoir ou modifier vos préférences',
    successButton: 'Mettre à jour mes préférences',
    errorTitle: 'Il y a une erreur avec le lien de redirection',
    errorButton: 'Redirection vers le site'
  },
  SectionAccount: {
    copied: 'Copié !'
  },
  SectionPointCard: {
    you: 'Vous',
    copied: 'Copié !'
  }
}
